export const themes = {
  none: {
    thRoot: '',
  },
  'heading-brand-1': {
    thRoot: 'text-black font-brand text-32 leading-tight',
  },
};
